// extracted by mini-css-extract-plugin
export var reviewCard = "review-module--reviewCard--7012d";
export var reviewCard__rating = "review-module--reviewCard__rating--0940d";
export var reviewCard__review = "review-module--reviewCard__review--8d3b5";
export var reviewCard__stars = "review-module--reviewCard__stars--51e99";
export var reviewCard__starsImage = "review-module--reviewCard__starsImage--a45a7";